import React, { useState } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
// import "react-accessible-accordion/dist/fancy-example.css";

export default function AdmissionAccordion() {
  const [openItems, setOpenItems] = useState([]);

  const handleToggle = (index) => {
    setOpenItems((prevOpenItems) => {
      const isOpen = prevOpenItems.includes(index);
      if (isOpen) {
        // If the item is already open, remove it from the array (close it)
        return prevOpenItems.filter((item) => item !== index);
      } else {
        // Otherwise, add it to the array (open it)
        return [...prevOpenItems, index];
      }
    });
  };
  return (
    <div>
      <Accordion allowMultipleExpanded allowZeroExpanded>
        {/* first */}
        <AccordionItem className="rounded-[15px] border-[0.5px] border-text-normal bg-primary-light px-6 py-4 mb-5">
          <AccordionItemHeading onClick={() => handleToggle(0)}>
            <AccordionItemButton className="flex items-center justify-between">
              <span className="font-montserrat font-semibold text-sm md:text-base leading-6  text-black">
                {" "}
                SIBLINGS PRIVILEGES
              </span>
              <div>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.9462 12.0004L8.34619 7.40043L9.39994 6.34668L15.0537 12.0004L9.39994 17.6542L8.34619 16.6004L12.9462 12.0004Z"
                    fill="#1C1B1F"
                    transform={openItems.includes(0) ? "rotate(90 12 12)" : ""}
                  />
                </svg>
              </div>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className=" pt-6 font-notoSans font-light text-sm md:text-base leading-6  text-primary-normal">
            <ul className="list-disc">
              <li className="flex items-start">
                <span className="font-bold w-32">Three Siblings:&nbsp;</span>
                <span>One child 50% less tuition fee</span>
              </li>
              <li className="flex items-start">
                <span className="font-bold w-32">Four Siblings:&nbsp;</span>
                <span>One child free tuition fee</span>
              </li>
              <li className="flex items-start">
                <span className="font-bold w-32">Five Siblings:&nbsp;</span>
                <ul className="">
                  <li>One child free tuition fee</li>
                  <li>One child 50% less tuition fee</li>
                  <li>One child 10% less tuition fee</li>
                </ul>
              </li>
              <li className="flex items-start">
                <span className="font-bold w-32">Six Siblings:&nbsp;</span>
                <ul className="">
                  <li>One child free tuition fee</li>
                  <li>One child 50% less tuition fee</li>
                  <li>One child 10% less tuition fee</li>
                </ul>
              </li>
            </ul>
          </AccordionItemPanel>
        </AccordionItem>
        {/* second */}
        <AccordionItem className="rounded-[15px] border-[0.5px] border-text-normal bg-primary-light px-6 py-4 mb-5">
          <AccordionItemHeading onClick={() => handleToggle(1)}>
            <AccordionItemButton className="flex items-center justify-between">
              <span className="font-montserrat font-semibold text-sm md:text-base leading-6  text-black">
                {" "}
                Unifast
              </span>
              <div>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.9462 12.0004L8.34619 7.40043L9.39994 6.34668L15.0537 12.0004L9.39994 17.6542L8.34619 16.6004L12.9462 12.0004Z"
                    fill="#1C1B1F"
                    transform={openItems.includes(1) ? "rotate(90 12 12)" : ""}
                  />
                </svg>
              </div>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className=" pt-6 font-notoSans font-light text-sm md:text-base leading-6  text-primary-normal">
            The Brothers and Sisters Scholarship Program is designed to support
            families with multiple children enrolled at the same time in our
            institution. We understand the financial commitment required to
            provide quality education for siblings, and this scholarship aims to
            ease the burden for families with more than one child attending our
            school.
          </AccordionItemPanel>
        </AccordionItem>
        {/* Third */}
        <AccordionItem className="rounded-[15px] border-[0.5px] border-text-normal bg-primary-light px-6 py-4 mb-5">
          <AccordionItemHeading onClick={() => handleToggle(2)}>
            <AccordionItemButton className="flex items-center justify-between">
              <span className="font-montserrat font-semibold text-sm md:text-base leading-6  text-black">
                BARMM
              </span>
              <div>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.9462 12.0004L8.34619 7.40043L9.39994 6.34668L15.0537 12.0004L9.39994 17.6542L8.34619 16.6004L12.9462 12.0004Z"
                    fill="#1C1B1F"
                    transform={openItems.includes(2) ? "rotate(90 12 12)" : ""}
                  />
                </svg>
              </div>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className=" pt-6 font-notoSans font-light text-sm md:text-base leading-6  text-primary-normal">
            The Brothers and Sisters Scholarship Program is designed to support
            families with multiple children enrolled at the same time in our
            institution. We understand the financial commitment required to
            provide quality education for siblings, and this scholarship aims to
            ease the burden for families with more than one child attending our
            school.
          </AccordionItemPanel>
        </AccordionItem>{" "}
        <AccordionItem className="rounded-[15px] border-[0.5px] border-text-normal bg-primary-light px-6 py-4 mb-5">
          <AccordionItemHeading onClick={() => handleToggle(3)}>
            <AccordionItemButton className="flex items-center justify-between">
              <span className="font-montserrat font-semibold text-sm md:text-base leading-6  text-black">
                MRP
              </span>
              <div>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.9462 12.0004L8.34619 7.40043L9.39994 6.34668L15.0537 12.0004L9.39994 17.6542L8.34619 16.6004L12.9462 12.0004Z"
                    fill="#1C1B1F"
                    transform={openItems.includes(3) ? "rotate(90 12 12)" : ""}
                  />
                </svg>
              </div>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className=" pt-6 font-notoSans font-light text-sm md:text-base leading-6  text-primary-normal">
            The Brothers and Sisters Scholarship Program is designed to support
            families with multiple children enrolled at the same time in our
            institution. We understand the financial commitment required to
            provide quality education for siblings, and this scholarship aims to
            ease the burden for families with more than one child attending our
            school.
          </AccordionItemPanel>
        </AccordionItem>{" "}
      </Accordion>
    </div>
  );
}
